import { mutationType } from '../mutations';
// TODO 임시 데이터
// import { dummyOrderList, dummyWorkerList } from '/tmp/mapControlDummyData.js';
export const actionType = {
    setIsOpenConfigDialog: 'setIsOpenConfigDialog',
    setSelectedItemKey: 'setSelectedItemKey',
    toggleStop: 'toggleStop',
    toggleWorkerList: 'toggleWorkerList',
};
const action = {
    [actionType.toggleWorkerList]({ commit }, isOpen) {
        commit(mutationType.TOGGLE_WORKER_LIST, isOpen);
    },
    [actionType.toggleStop]({ state, commit }) {
        const flag = state.isStop;
        commit('SET_IS_STOP', !flag);
    },
    [actionType.setIsOpenConfigDialog]({ commit }, isOpen) {
        commit('SET_IS_OPEN_CONFIG_DIALOG', isOpen);
    },
    [actionType.setSelectedItemKey]({ commit }, key = -1) {
        commit('SET_SELECTED_ITEM_KEY', key);
    },
};
export default action;
